import { z } from 'zod';

export const ZodIssue = z.object({
  /** The type of validation that was performed, e.g. email */
  validation: z.string().optional(),
  /** The validation response code, e.g. invalid_string */
  code: z.string().optional(),
  /** A human readable, but not necessarily customer-friendly message */
  message: z.string().optional(),
  /** The path that failed validation */
  path: z.array(z.union([z.string(), z.number()])).optional(),
});

export const ZodValidationError = z.object({
  name: z.literal('ZodError'),
  issues: z.array(ZodIssue),
});

/** The Zod schema that represents the structure of a JSON object returned when a TSRest response fails its Zod
 * request validation */
export const ZodValidationErrorResponse = z.object({
  // I don't know what type paramsResult should be, but we don't need it right now
  paramsResult: z.unknown(),
  // I don't know what type headersResult should be, but we don't need it right now
  headersResult: z.unknown(),
  // I don't know what type queryResult should be, but we don't need it right now
  queryResult: z.unknown(),
  bodyResult: ZodValidationError.optional(),
});
